import { render, staticRenderFns } from "./ActionBox.vue?vue&type=template&id=e23cfbb2"
import script from "./ActionBox.vue?vue&type=script&lang=ts"
export * from "./ActionBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports